module.exports = __webpack_public_path__ + "img/gallagher-globe-logo-flat-border.172d6b23.svg";